import { render, staticRenderFns } from "./public.vue?vue&type=template&id=f12bd2b4&scoped=true&"
import script from "./public.vue?vue&type=script&lang=js&"
export * from "./public.vue?vue&type=script&lang=js&"
import style0 from "./public.vue?vue&type=style&index=0&id=f12bd2b4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f12bd2b4",
  null
  
)

export default component.exports